import { createReducer, on } from "@ngrx/store";
import { GetAdhocReportResponse, GetCardConfigurationResponse, GetCardListForReportResponse, GetDefaultFilterResponse, GetDefaultTemplateResponse, GetTemplateResponse, GetTemplatesResponse } from "@ptg-member/types/models/adhoc-report.model";
import { BaseActionState } from "@ptg-shared/types/models";
import * as AdhocReportActions from "../actions/adhoc-report.actions";
import { ACTION, ActionState, STATE } from "@ptg-shared/constance";

export interface AdhocReportState {
  getCardList?: BaseActionState<GetCardListForReportResponse>;
  getDefaultFilter?: BaseActionState<GetDefaultFilterResponse>;
  getDefaultTemplate?: BaseActionState<GetDefaultTemplateResponse>;
  getCardConfiguration?: BaseActionState<GetCardConfigurationResponse>;
  getTemplates?: BaseActionState<GetTemplatesResponse>;
  getTemplate?: BaseActionState<GetTemplateResponse>;
  getAdhocReport?: BaseActionState<GetAdhocReportResponse>
  generateAdhocReport?: ActionState;
  createReportTemplate?: Partial<ActionState> & { templateName?: string };
  updateReportTemplate?: Partial<ActionState> & { templateName?: string };
  removeReportTemplate?: ActionState;
  removeReportAuditTrail?: ActionState;
}



const initialState: AdhocReportState = {};

export const adhocReportReducer = createReducer(
  initialState,
  on(AdhocReportActions.getCardListAction, (state) => ({
    ...state,
    getCardList: {
      isLoading: true,
    },
  })),
  on(AdhocReportActions.getCardListSuccessAction, (state, { response }) => ({
    ...state,
    getCardList: {
      isLoading: false,
      success: true,
      payload: response,
    },
  })),
  on(AdhocReportActions.getCardListFailAction, (state, { error }) => ({
    ...state,
    getCardList: {
      isLoading: false,
      success: false,
      error: error,
    },
  })),
  on(AdhocReportActions.clearCardListStateAction, (state) => ({
    ...state,
    getCardList: undefined,
  })),
  on(AdhocReportActions.getDefaultFilterAction, (state) => ({
    ...state,
    getDefaultFilter: {
      isLoading: true,
    },
  })),
  on(AdhocReportActions.getDefaultFilterSuccessAction, (state, { response }) => ({
    ...state,
    getDefaultFilter: {
      isLoading: false,
      success: true,
      payload: response,
    },
  })),
  on(AdhocReportActions.getDefaultFilterFailAction, (state, { error }) => ({
    ...state,
    getDefaultFilter: {
      isLoading: false,
      success: false,
      error: error,
    },
  })),
  on(AdhocReportActions.clearDefaultFilterStateAction, (state) => ({
    ...state,
    getDefaultFilter: undefined,
  })),
  on(AdhocReportActions.getDefaultTemplateAction, (state) => ({
    ...state,
    getDefaultTemplate: {
      isLoading: true,
    },
  })),
  on(AdhocReportActions.getDefaultTemplateSuccessAction, (state, { response }) => ({
    ...state,
    getDefaultTemplate: {
      isLoading: false,
      success: true,
      payload: response,
    },
  })),
  on(AdhocReportActions.getDefaultTemplateFailAction, (state, { error }) => ({
    ...state,
    getDefaultTemplate: {
      isLoading: false,
      success: false,
      error: error,
    },
  })),
  on(AdhocReportActions.clearDefaultTemplateStateAction, (state) => ({
    ...state,
    getDefaultTemplate: undefined,
  })),
  on(AdhocReportActions.getCardConfigurationAction, (state) => ({
    ...state,
    getCardConfiguration: {
      isLoading: true,
    },
  })),
  on(AdhocReportActions.getCardConfigurationSuccessAction, (state, { response }) => ({
    ...state,
    getCardConfiguration: {
      isLoading: false,
      success: true,
      payload: response,
    },
  })),
  on(AdhocReportActions.getCardConfigurationFailAction, (state, { error }) => ({
    ...state,
    getCardConfiguration: {
      isLoading: false,
      success: false,
      error: error,
    },
  })),
  on(AdhocReportActions.clearCardConfigurationStateAction, (state) => ({
    ...state,
    getCardConfiguration: undefined,
  })),
  on(AdhocReportActions.getTemplatesAction, (state) => ({
    ...state,
    getTemplates: {
      isLoading: true,
    },
  })),
  on(AdhocReportActions.getTemplatesSuccessAction, (state, { response }) => ({
    ...state,
    getTemplates: {
      isLoading: false,
      success: true,
      payload: response,
    },
  })),
  on(AdhocReportActions.getTemplatesFailAction, (state, { error }) => ({
    ...state,
    getTemplates: {
      isLoading: false,
      success: false,
      error: error,
    },
  })),
  on(AdhocReportActions.clearTemplatesStateAction, (state) => ({
    ...state,
    getTemplates: undefined,
  })),
  on(AdhocReportActions.getTemplateAction, (state) => ({
    ...state,
    getTemplate: {
      isLoading: true,
    },
  })),
  on(AdhocReportActions.getTemplateSuccessAction, (state, { response }) => ({
    ...state,
    getTemplate: {
      isLoading: false,
      success: true,
      payload: response,
    },
  })),
  on(AdhocReportActions.getTemplateFailAction, (state, { error }) => ({
    ...state,
    getTemplate: {
      isLoading: false,
      success: false,
      error: error,
    },
  })),
  on(AdhocReportActions.clearTemplateStateAction, (state) => ({
    ...state,
    getTemplate: undefined,
  })),
  on(AdhocReportActions.generateAdhocReportAction, (state) => ({
    ...state,
    generateAdhocReport: undefined
  })),
  on(AdhocReportActions.generateAdhocReportSuccessAction, (state) => ({
    ...state,
    generateAdhocReport: {
      action: ACTION.GENERATE,
      state: STATE.SUCCESS
    },
  })),
  on(AdhocReportActions.generateAdhocReportFailAction, (state, { error }) => ({
    ...state,
    generateAdhocReport: {
      action: ACTION.GENERATE,
      state: STATE.FAIL
    },
  })),
  on(AdhocReportActions.clearGenerateAdhocReportStateAction, (state) => ({
    ...state,
    generateAdhocReport: undefined,
  })),
  on(AdhocReportActions.createReportTemplateAction, (state, { request }) => ({
    ...state,
    createReportTemplate: {
      templateName: request.templateName
    }
  })),
  on(AdhocReportActions.createReportTemplateSuccessAction, (state) => ({
    ...state,
    createReportTemplate: {
      ...state.createReportTemplate,
      action: ACTION.ADD,
      state: STATE.SUCCESS
    },
  })),
  on(AdhocReportActions.createReportTemplateFailAction, (state, { error }) => ({
    ...state,
    createReportTemplate: {
      ...state.createReportTemplate,
      action: ACTION.ADD,
      state: STATE.FAIL,
    },
  })),
  on(AdhocReportActions.clearCreateReportTemplateStateAction, (state) => ({
    ...state,
    createReportTemplate: undefined,
  })),
  on(AdhocReportActions.updateReportTemplateAction, (state, { request }) => ({
    ...state,
    updateReportTemplate: {
      templateName: request.templateName
    }
  })),
  on(AdhocReportActions.updateReportTemplateSuccessAction, (state) => ({
    ...state,
    updateReportTemplate: {
      ...state.updateReportTemplate,
      action: ACTION.EDIT,
      state: STATE.SUCCESS
    },
  })),
  on(AdhocReportActions.updateReportTemplateFailAction, (state, { error }) => ({
    ...state,
    updateReportTemplate: {
      ...state.updateReportTemplate,
      action: ACTION.EDIT,
      state: STATE.FAIL
    },
  })),
  on(AdhocReportActions.clearUpdateReportTemplateStateAction, (state) => ({
    ...state,
    updateReportTemplate: undefined,
  })),
  on(AdhocReportActions.removeReportTemplateAction, (state) => ({
    ...state,
    removeReportTemplate: undefined
  })),
  on(AdhocReportActions.removeReportTemplateSuccessAction, (state) => ({
    ...state,
    removeReportTemplate: {
      action: ACTION.REMOVE,
      state: STATE.SUCCESS
    },
  })),
  on(AdhocReportActions.removeReportTemplateFailAction, (state, { error }) => ({
    ...state,
    removeReportTemplate: {
      action: ACTION.REMOVE,
      state: STATE.FAIL
    },
  })),
  on(AdhocReportActions.clearRemoveReportTemplateStateAction, (state) => ({
    ...state,
    removeReportTemplate: undefined,
  })),

  on(AdhocReportActions.removeReportAuditTrailAction, (state) => ({
    ...state,
    removeReportAuditTrail: undefined
  })),
  on(AdhocReportActions.removeReportAuditTrailSuccessAction, (state) => ({
    ...state,
    removeReportAuditTrail: {
      action: ACTION.REMOVE,
      state: STATE.SUCCESS
    },
  })),
  on(AdhocReportActions.removeReportAuditTrailFailAction, (state, { error }) => ({
    ...state,
    removeReportAuditTrail: {
      action: ACTION.REMOVE,
      state: STATE.FAIL
    },
  })),
  on(AdhocReportActions.clearRemoveReportAuditTrailStateAction, (state) => ({
    ...state,
    removeReportAuditTrail: undefined,
  })),

  on(AdhocReportActions.getAdhocReportAction, (state) => ({
    ...state,
    getAdhocReport: {
      isLoading: true,
    },
  })),
  on(AdhocReportActions.getAdhocReportSuccessAction, (state, { response }) => ({
    ...state,
    getAdhocReport: {
      isLoading: false,
      success: true,
      payload: response,
    },
  })),
  on(AdhocReportActions.getAdhocReportFailAction, (state, { error }) => ({
    ...state,
    getAdhocReport: {
      isLoading: false,
      success: false,
      error: error,
    },
  })),
  on(AdhocReportActions.clearAdhocReportStateAction, (state) => ({
    ...state,
    getAdhocReport: undefined,
  }))
);
